<template>
  <v-layout
    wrap
    align-center
  >
    <v-flex
      md12
      xs12
      text-center
      mb-4
    >
      <h2 class="mt-1">
        Важно!
      </h2>
      <span style="font-size:16px;">
        {{ $t('packs.letYouGo') }}
      </span>
    </v-flex>
    <v-flex
      md12
      xs12
      :class="$vuetify.breakpoint.xs ? 'mb-4' : 'text-center'"
      text-center
    >
      <v-avatar
        :tile="false"
        :size="$vuetify.breakpoint.xs ? '80' : '100'"
        :class="$vuetify.breakpoint.xs ? 'mr-4' : ''"
      >
        <v-img
          :src="require('@/images/daniil.png')"
          :lazy-src="require('@/images/daniil.png')"
          height="300"
          contain
        />
      </v-avatar>
      <span
        style="display:block; line-height:14px;"
      >
        <br><b>Daniil Chabanets</b><br>
        <small>Co-Founder</small>
      </span>
    </v-flex>
    <v-flex
      xs12
      mt-5
      mb-5
      text-center
    >
      <v-btn
        class="primary"
        large
        @click="makeCall(true)"
      >
        {{ $t("packs.sheduleZoom") }}
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "MakeCall",
  methods: {
    makeCall(val) {
      this.$emit('makeCall', val)
      if (val) {
        gtag('event', 'Call Scheduled', {
          'event_category': 'Package Sales',
          'event_label': 'Schedule Call',
        });
      }
      if (!val) {
         gtag('event', 'Call Refused', {
          'event_category': 'Package Sales',
          'event_label': 'Schedule Call',
        });
        this.$router.push('/calculator')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bullets {
  font-size:16px;
}
</style>